import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ScheduleSessionService {

  constructor(private http: HttpClient) { }

  getMyPatientList = (req: Object) => this.http.post<any>(environment.baseUrl + "patientManagement/user/searchPatinetList", req)

  searchPatients = (req: Object) => this.http.post<any>(environment.baseUrl + "patientManagement/user/search", req)

  postOnlineSession = (req: FormData) => this.http.post<any>(environment.baseUrl + "OnlineSessions/HCP/Create", req)

  createDynamicLink = (req: Object) => this.http.post<any>("https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=AIzaSyByGefpW2cKUQotHB1tLFmbe14e3KTbCsI", req)

  setDynamicLink = (req: FormData, id: number) => this.http.post<any>(environment.baseUrl + "OnlineSessions/SetDeepLink/" + id, req)

}
